<div style="height: 100%" data-cy="referral-manager-container">
  <div class="section-header" data-cy="referral-manager-header">
    <div class="section-header-title" data-cy="referral-manager-title">Referral Management</div>
  </div>
  <div style="display: flex; flex-direction: column; flex: 1; height: 100%" data-cy="referral-manager-content">
    <div style="display: flex; flex-direction: row; height: 100%;width: 100%;" data-cy="referral-manager-columns">
      <div class="column1" style="border: 1px solid var(--tdo-blue); height: 95%;margin-top: 10px;" data-cy="referral-manager-left-column">
        <h6 style="background-color: var(--tdo-primary); color: white; width: 100%; padding-left: 20px" data-cy="referral-manager-unhandled-header">Unhandled
          Referrals</h6>
        <div style="display: flex; flex-direction: column; flex: 1; height: inherit" data-cy="referral-manager-list-container">
          <div style="flex-basis: fit-content; padding: 0px 10px 0px 10px" data-cy="referral-manager-status-filter">
            <app-validvalueselect *ngIf="referralStatus.length > 0" style="width:90%" [disabled]="false"
                                  data-cy="referral-manager-status-select" validvaluename="enumReferralStatus"
                                  [showNoneOption]="false"
                                  [dataSource]="referralStatus"
                                  (selectedValueChange)="changeStatus($event)"
                                  [(selectedValue)]="referralFilter.referralStatusID"
                                  vvplaceholder="Status"></app-validvalueselect>
            <mat-icon matTooltip="Reload List"
                      style="color: var(--tdo-primary); margin-bottom: 10px; margin-left: 8px; cursor: pointer;"
                      (click)="getReferralList(true)" data-cy="referral-manager-reload-button">autorenew
            </mat-icon>
          </div>

          <div style="flex-basis: fit-content; padding: 0px 10px 0px 10px" data-cy="referral-manager-search-container">
            <app-tdo-input placeholder="Search" [(ngModel)]="referralSearch"
                           (input)="changeFilter($event)" data-cy="referral-manager-search-input"></app-tdo-input>
          </div>
          <div style="width: 100%; height: 100%; vertical-align: center" *ngIf="isLoading" data-cy="referral-manager-loading">
            <app-tdo-progress-spinner data-cy="referral-manager-spinner"></app-tdo-progress-spinner>
          </div>
          <mat-button-toggle-group *ngIf="!isLoading" style="height: 80%" data-cy="referral-manager-list">
            <mat-button-toggle [checked]="ref === selectedRef" class="vertical" *ngFor="let ref of referralsFilter"
                               [value]="ref" (click)="selectRef(ref)"
                               [ngClass]="{'selectedCLass': ref === selectedRef}" data-cy="referral-manager-list-item">
              <div style="display: flex; flex-direction:row; flex: 1; width: 100%" data-cy="referral-manager-item-content">
                <div style="display: flex; flex-direction:column; flex: 1; width: 70%" data-cy="referral-manager-item-details">
                  <div style="display: flex; flex-direction:row" data-cy="referral-manager-item-received">
                    <span style="font-weight: bold" data-cy="referral-manager-received-label">Received:</span>
                    <span class="span" data-cy="referral-manager-received-date">({{getLocalDate(ref.ReferralTime) | date: 'short'}}) </span>
                  </div>
                  <div style="display: flex; flex-direction:row" data-cy="referral-manager-item-from">
                    <span style="font-weight: bold" data-cy="referral-manager-from-label">From:</span>
                    <span class="span" data-cy="referral-manager-from-doctor"
                          *ngFor="let doc of referringDocs | ReferralDoctorPipe: ref.RefDoctorID">{{doc.FullName}}</span>
                  </div>
                  <div style="display: flex; flex-direction:row" data-cy="referral-manager-item-patient">
                    <span style="font-weight: bold" data-cy="referral-manager-patient-label">Patient:</span>
                    <span class="span" data-cy="referral-manager-patient-name">{{ref.Patient_FirstName}} {{ref.Patient_LastName}}
                    ({{ref.Patient_DOB | date: 'MM-dd-YYYY'}})</span>
                  </div>
                  <div style="display: flex; flex-direction:row" data-cy="referral-manager-item-for">
                    <span style="font-weight: bold" data-cy="referral-manager-for-label">For:</span>
                    <span class="span" data-cy="referral-manager-for-doctor"
                          *ngFor="let docTDO of listTDOProvidersDoctors | ProviderReferringDoctorPipe: ref.ProviderID">
                      {{docTDO.dataContact.FirstName}} {{docTDO.dataContact.LastName}} </span>
                  </div>
                </div>
                <img style="object-fit: contain" [src]="getIconByEnumType(ref.enumReferralScheduleTypeID)"
                     [matTooltip]="imageTooltip" data-cy="referral-manager-item-icon"/>
              </div>
            </mat-button-toggle>
          </mat-button-toggle-group>
          <div style="width: 100%; display: flex; justify-content:center; padding-top: 25px;" data-cy="referral-manager-actions">
            <tdo-button (click)="cancel(selectedRef)" class="tdo-button tdox-btn-danger"
                        style="padding:4px;margin-left: 10px;" data-cy="referral-manager-remove-button">Remove Referral Request
            </tdo-button>
          </div>
        </div>
      </div>
      <div class="column2" *ngIf="!selectedRef" data-cy="referral-manager-empty-right-column">
      </div>
      <div class="column2" *ngIf="selectedRef" data-cy="referral-manager-right-column">
        <div style="display: flex; flex-direction: column; margin-top: 10px; width: 50%" data-cy="referral-manager-detail-cards">
          <mat-card class="Card-style" style="height: 160px" data-cy="referral-manager-doctor-card">
            <mat-card-title-group>
              <mat-card-title class="Card-title" data-cy="referral-manager-doctor-title">Referring Doctor</mat-card-title>
            </mat-card-title-group>
            <mat-card-content *ngIf="this.selectedDoc" data-cy="referral-manager-doctor-content">
              <div style="display: flex; flex: 1; flex-direction: column; margin: 5px;justify-content:flex-start" data-cy="referral-manager-doctor-details">
                <span style="font-weight: bold" class="span" data-cy="referral-manager-doctor-name">{{this.selectedDoc.FullName}}</span>
                <span class="span" data-cy="referral-manager-doctor-email">{{this.selectedDoc.email}}</span>
                <span class="span" data-cy="referral-manager-doctor-phone">{{this.selectedDoc.phone}}</span>
              </div>
              <div style="width: 100%; display: flex;flex-direction: row; border-top: solid 1px var(--tdo-blue-light)" data-cy="referral-manager-doctor-actions">
                <span *ngIf=!matchReferralDoctor
                      style="width: 90%; padding-left: 5px; padding-top: 10px" data-cy="referral-manager-doctor-no-match">No match found</span>
                <span *ngIf="matchReferralDoctor && this.dataReferralDoctor.FullName"
                      style="width: 90%; padding-left: 5px; padding-top: 10px" data-cy="referral-manager-doctor-match">{{this.dataReferralDoctor.FullName}}</span>
                <div
                  *ngIf="listTDOReferralDoctor.length > 0 && selectedRef.enumReferralStatusID === EnumReferralStatusPending"
                  style="padding-left: 5px; padding-top: 10px"
                  matTooltip="Find Referring Doctor"
                  (click)="findDrOnList($event)" data-cy="referral-manager-doctor-find-button">
                  <mat-icon>settings_ethernet</mat-icon>
                </div>
                <div *ngIf="selectedRef.enumReferralStatusID === EnumReferralStatusPending"
                     style="padding-left: 5px; padding-top: 10px" matTooltip="Add new referring doctor"
                     (click)="createReferringDoctor($event)" data-cy="referral-manager-doctor-add-button">
                  <mat-icon>add_circle_outline</mat-icon>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
          <mat-card class="Card-style" style="height: 180px; margin-top: 5px" data-cy="referral-manager-patient-card">
            <mat-card-title-group>
              <mat-card-title class="Card-title" data-cy="referral-manager-patient-title">Patient</mat-card-title>
            </mat-card-title-group>
            <mat-card-content data-cy="referral-manager-patient-content">
              <div style="display: flex; flex: 1; flex-direction: column; margin: 5px;justify-content:flex-start" data-cy="referral-manager-patient-details">
                <span class="span" data-cy="referral-manager-patient-fullname">{{this.selectedRef.Patient_LastName}}
                  , {{this.selectedRef.Patient_FirstName}} {{this.selectedRef.Patient_MidName}}</span>
                <span class="span" data-cy="referral-manager-patient-dob">DOB: {{this.selectedRef.Patient_DOB | date: 'MM-dd-YYYY'}}</span>
                <span class="span" data-cy="referral-manager-patient-email">{{this.selectedRef.Patient_email}}</span>
                <span class="span" data-cy="referral-manager-patient-phone">{{this.selectedRef.Patient_phone | formatPhone}}</span>
              </div>
              <div style="width: 100%; display: flex;flex-direction: row; border-top: solid 1px var(--tdo-blue-light)">
                <div style="width: 85%; display: flex;flex-direction: row;">
                  <span *ngIf="!matchReferralPatient && !isShowPatientSearch"
                      style="width: 90%; padding-left: 5px; padding-top: 10px">No match found</span>
                  <span *ngIf="matchReferralPatient && !isShowPatientSearch"
                        style="width: 90%; padding-left: 5px; padding-top: 10px">{{this.matchPatientFullName}}</span>
                  <div *ngIf="isShowPatientSearch" style="width: 100%; height: 100%; padding: 4px 10px 1px 10px;">
                    <div style="display: flex; width: 100%; height: fit-content;">
                      <div
                        style="color: var(--tdo-primary-accent); height: fit-content; font-weight: 500; flex-basis: fit-content;">
                        Patient Name:
                      </div>
                      <div style="flex: 1;"></div>
                      <div matTooltip="Close" (click)="closeSearch()"
                           style="cursor: pointer; height: 20px; flex-basis: fit-content;">
                        <mat-icon>close</mat-icon>
                      </div>
                    </div>
                    <div style="background-color: var(--tdo-background); padding: 2px; border-radius: 6px;">
                      <tdo-patient-search #tps (patientSelect)="selectPatient($event)"
                                          [isChangeUser]="false"></tdo-patient-search>
                    </div>
                  </div>
                </div>
                <div *ngIf="selectedRef.enumReferralStatusID === EnumReferralStatusPending" matTooltip="Search Patient"
                     style="cursor: pointer; width: fit-content; height: 26px; margin-left: auto; margin-right: auto; color: var(--tdo-primary-accent); padding-top: 10px"
                     (click)="onSearchPatientClick()">
                  <mat-icon>search</mat-icon>
                </div>
                <div
                  *ngIf="selectedRef.enumReferralStatusID === EnumReferralStatusPending"
                  style="padding-left: 5px; padding-top: 10px; margin-left: auto" matTooltip="Add new Patient"
                  (click)="handlePatient($event)">
                  <mat-icon>add_circle_outline</mat-icon>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
          <mat-card class="Card-style" style="height: 180px; margin-top: 5px" data-cy="referral-manager-insurance-card">
            <mat-card-title-group>
              <mat-card-title class="Card-title" data-cy="referral-manager-insurance-title">Insurance</mat-card-title>
            </mat-card-title-group>
            <mat-card-content data-cy="referral-manager-insurance-content">
              <div style="display: flex; flex: 1; flex-direction: column; margin: 5px;justify-content:flex-start" data-cy="referral-manager-insurance-details">
                <span class="span" data-cy="referral-manager-insurance-holder">Policy Holder: {{this.selectedRef.Insurance_LastName}}
                  , {{this.selectedRef.Insurance_FirstName}}</span>
                <span class="span" data-cy="referral-manager-insurance-dob">DOB: {{this.selectedRef.Insurance_DOB | date: 'MM-dd-YYYY'}}</span>
                <span class="span" data-cy="referral-manager-insurance-company">Insurance Company:{{this.selectedRef.Insurance_Company}}</span>
                <span class="span" data-cy="referral-manager-insurance-number">Insurance Number:{{this.selectedRef.Insurance_Number}}</span>
              </div>
              <div
                   style="width: 100%; display: flex;flex-direction: row; border-top: solid 1px var(--tdo-blue-light)">
                <span *ngIf="!matchReferralInsurance"
                      style="width: 90%; padding-left: 5px; padding-top: 10px">No match found</span>
                <span *ngIf="matchReferralInsurance"
                      style="width: 90%; padding-left: 5px; padding-top: 10px">{{this.matchReferralInsuranceName}}</span>

                <div
                  *ngIf="listMatchTDOInsurances.length > 0 && selectedRef.enumReferralStatusID === EnumReferralStatusPending"
                  style="padding-left: 5px; padding-top: 10px"
                  matTooltip="Find Patient Insurance"
                  (click)="findPatientInsuranceOnList($event)">
                  <mat-icon>settings_ethernet</mat-icon>
                </div>
                <div *ngIf="selectedRef.enumReferralStatusID === EnumReferralStatusPending"
                     style="padding-left: 5px; padding-top: 10px; margin-left: auto" matTooltip="Add new Insurance"
                     (click)="handleInsurance($event)">
                  <mat-icon>add_circle_outline</mat-icon>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
          <mat-card class="Card-style" style="height: 180px; margin-top: 5px" data-cy="referral-manager-attachments-card">
            <mat-card-title-group>
              <mat-card-title class="Card-title" data-cy="referral-manager-attachments-title">Attachments</mat-card-title>
            </mat-card-title-group>
            <mat-card-content data-cy="referral-manager-attachments-content">
              <div style="display: flex; flex: 1; flex-direction: column; margin: 5px;justify-content:flex-start" data-cy="referral-manager-attachments-grid">
                <mat-grid-list cols="4" rowHeight="100px" data-cy="referral-manager-attachments-list">
                  <mat-grid-tile *ngFor="let img of this.selectedRef.dataReferralAttachments" data-cy="referral-manager-attachment-item">
                    <ng-container *ngIf="img.url.endsWith('.pdf'); else imageTemplate">
                      <a [href]="img.url" download data-cy="referral-manager-attachment-pdf">
                        <mat-icon class="large-pdf-icon">picture_as_pdf</mat-icon>
                      </a>
                    </ng-container>
                    <ng-template #imageTemplate>
                      <img width="100px" src="{{img.url}}" title="{{img.name}}" data-cy="referral-manager-attachment-image" />
                    </ng-template>
                  </mat-grid-tile>
                </mat-grid-list>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
        <div style="display: flex; flex-direction: column; margin-top: 10px; padding-left: 10px; width: 50%">
          <mat-card class="Card-style" style="height: 345px">
            <mat-card-title-group>
              <mat-card-title class="Card-title">
                <mat-label style="font-weight: bold">Treatments Requested (<span
                  *ngIf="this.selectedRef.ToothIDsJSON && this.selectedRef.ToothIDsJSON.length>0">Teeth: {{this.selectedRef.ToothIDsJSON}}</span>)
                </mat-label>
              </mat-card-title>
            </mat-card-title-group>
            <mat-card-content>
              <div style="display: flex; flex: 1; flex-direction: column; margin: 5px;justify-content:flex-start">
                <mat-list
                  style="overflow-y: auto; font-size: small; border: 0px solid var(--tdo-purple-light); border-radius: 10px; width: 100%; height: 80%;margin: 4%">
                  <div
                    *ngIf="this.treatmentsSelected && this.treatmentsSelected.length>0 && this.treatmentsSelected[0] !== ''">
                    <mat-list-item *ngFor="let treat of this.treatmentsSelected" style="border-bottom: 1px solid grey">
                  <span style="font-size: small"
                        *ngFor="let pro of this.procedures | filterTreatments: treat.toString()">{{pro.ItemName}}</span>
                    </mat-list-item>
                  </div>
                  <div *ngIf="this.othTreatments && this.othTreatments.length>0 && this.othTreatments[0] !== ''">
                    <mat-list-item *ngFor="let Othertreat of this.othTreatments" style="border-bottom: 1px solid grey">
                  <span style="font-size: small"
                        *ngFor="let pro of this.otherServices | filterOthTreatments: Othertreat.toString()">{{pro.ItemName}}</span>
                    </mat-list-item>
                  </div>
                </mat-list>
              </div>
            </mat-card-content>
          </mat-card>
          <mat-card class="Card-style" style="height: 180px; margin-top: 5px">
            <mat-card-title-group>
              <mat-card-title class="Card-title">Notes</mat-card-title>
            </mat-card-title-group>
            <mat-card-content>
              <div style="display: flex; flex: 1; flex-direction: column; margin: 5px;justify-content:flex-start">
                <span class="span">Discomfort: {{this.selectedRef.DiscomfortLevel}}</span>
                <span class="span">Other Note(s):</span>
                <mat-form-field>
                  <textarea matInput [(ngModel)]="selectedRef.Notes" [attr.data-cy]="'Notes'"></textarea>
                </mat-form-field>
              </div>
            </mat-card-content>
          </mat-card>
          <mat-card class="Card-style" style="height: 180px; margin-top: 5px">
            <mat-card-title-group>
              <mat-card-title class="Card-title">Appointment</mat-card-title>
            </mat-card-title-group>
            <mat-card-content>
              <div style="display: flex; flex: 1; flex-direction: column; margin: 5px;justify-content:flex-start">
                <div style="display: flex; flex: 1; flex-direction: row;" [class.readonly]="true">
                  <mat-label>Location:</mat-label>
                  <span *ngIf="this.selectedLocation" class="span">{{this.selectedLocation.Name}}</span>
                </div>
                <div style="display: flex; flex: 1; flex-direction: row" [class.readonly]="true">
                  <mat-label>Date:</mat-label>
                  <span *ngIf="this.appointmentStartDateTime"
                        class="span">{{getDate(appointmentStartDateTime)  | date: 'shortDate'  }}  </span>
                </div>
                <div style="display: flex; flex: 1; flex-direction: row;" [class.readonly]="true">
                  <mat-label>Start Time:</mat-label>
                  <span *ngIf="this.appointmentStartDateTime"
                        class="span">{{getDate(appointmentStartDateTime)  | date: 'shortTime'  }}  </span>
                </div>
                <div style="display: inline-flex; flex-direction: row;" [class.readonly]="true">
                  <mat-label>Duration:</mat-label>
                  <span *ngIf="this.appointmentDuration" class="span">{{this.appointmentDuration}}</span>
                </div>
                <div style="display: flex; flex: 1; flex-direction: row; align-self: end">
                  <div *ngIf="selectedRef.enumReferralStatusID === EnumReferralStatusPending">
                    <img (click)="createAppointment()" src="../../../assets/icons/icons8_calendar_plus.svg"
                         matTooltip="Create Appointment" style="width: 35px">
                  </div>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
</div>
